import type { FC } from "react";

import { trackEvent } from "../../../utils/amplitude";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { useQueryParamsActions } from "utils/routing";

interface StopFollowingButtonProps {
  color: PresentationBannerColorType;
}

export const StopFollowingButton: FC<StopFollowingButtonProps> = ({ color }) => {
  const { deleteQueryParams } = useQueryParamsActions();

  const onClick = () => {
    trackEvent("Presentation - Stop following", { eventCategory: "Button press" });
    deleteQueryParams([FOLLOWING_QUERY_PARAM]);
  };

  return (
    <PillBannerButton
      kind={`banner-${color}`}
      title={t("tooltip.stop_following")}
      onClick={onClick}
    >
      {t("common.stop")}
    </PillBannerButton>
  );
};
